import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';

export interface IntercomState {
    initialised: boolean;
}

const initialState: IntercomState = {
    initialised: false,
};

const intercom = createSlice({
    name: 'intercom',
    initialState,
    reducers: {
        setInitialised(state: IntercomState, { payload }: PayloadAction<boolean>): void {
            state.initialised = payload;
        },
    },
});

export const { setInitialised } = intercom.actions;

export default intercom.reducer;

const intercomState = (state: RootState): IntercomState => state.intercom;

export const selectIntercominitialised = createSelector(intercomState, (state) => state.initialised);
